<template>
  <div class="add-ticket-modal">
    <el-dialog
      :title="$t('customerService.add_work_order')"
      :visible.sync="dialogUploadVisible"
      width="630px"
      :close-on-click-modal="false"
      class="diglog-card"
      @close="handleDialogClose"
      @open="handleDialogOpen"
    >
      <div class="content">
        <div class="section-title mb-12 mt-12" style="margin-top:0">
          {{ $t('customerService.business_type') }}
        </div>
        <div class="section-tip line-bottom-1px" style="padding-bottom: 5px;">
          {{ $t('tips.choose_transaction') }}
        </div>

        <el-form ref="form" label-width="230px" :model="form" :rules="rules" label-position="left">
          <!--业务类型  -->
          <el-form-item prop="operation_type" :label="$t('customerService.business_type')" required>
            <el-select v-model="form.operation_type" style="width: 100%;" clearable>
              <el-option
                key="1"
                :label=" $t('data.payin_transaction')"
                :value="1"
              />
              <el-option
                key="2"
                :label="$t('data.payout_transaction')"
                :value="2"
              />
              <el-option
                key="4"
                :label="$t('data.refund_transaction')"
                :value="4"
              />

            </el-select>

          </el-form-item>
          <div v-if="form.operation_type === 1">
            <div class="section-title mb-12 mt-12">
              {{ $t('data.payin_details') }}
            </div>
            <!-- <div class="section-tip">
              {{ $t('tips.choose_type_and_fill_ticket') }}
            </div> -->
            <!-- <el-form-item
              :label="$t('customerService.payment_method') + ':'"
              prop="payment_method"
              required
            >
              <el-select v-model="form.payment_method" clearable @change="changePaymethod">
                <el-option
                  v-for="(item,index) in paymentMethodArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item> -->
          </div>
          <div v-if="form.operation_type === 2">
            <div class="section-title mb-12 mt-12">
              {{ $t('data.payout_details') }}
            </div>
            <div class="section-tip line-bottom-1px" style="padding-bottom: 5px;">
              {{ $t('tips.fill_out_ticket_detail') }}
            </div>
          </div>

          <div v-if="form.operation_type === 4">
            <div class="section-title mb-12 mt-12">
              {{ $t('data.refund_details') }}
            </div>
            <div class="section-tip line-bottom-1px" style="padding-bottom: 5px;">
              {{ $t('tips.fill_out_ticket_detail') }}
            </div>
          </div>

          <el-row>
            <el-col :span="24">
              <!--商户订单号 - payout-->
              <el-form-item v-if="form.operation_type === 1 || form.operation_type === 2" key="merchant_order_id_d" prop="merchant_order_id">
                <template slot="label">
                  <span>{{ $t('merchantAccount.merchant_order_id') }}</span>
                  <el-tooltip>
                    <div slot="content">
                      <span> {{ $t('tips.payout_mch_order_id') }}</span> <br>
                    </div>
                    <span>  <svg-icon style="position:relative; top: -1px" icon-class="help-question" /></span>
                  </el-tooltip>
                </template>
                <el-input v-model.trim="form.merchant_order_id" class="from-input" placeholder="Enter Merchant Order ID" type="text" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <template v-if="form.operation_type === 4">
            <el-form-item
              key="original_transaction_id"
              :label="$t('customerService.original_transaction_id') + ':'"
              prop="original_transaction_id"
              required
            >
              <el-input v-model.trim="form.original_transaction_id" placeholder="Original transaction ID" class="from-input" size="small" type="text" clearable />
            </el-form-item>

            <!--商户订单号 - payout-->
            <el-form-item
              key="original_transaction_amount"
              :label="$t('customerService.original_transaction_amount') + ':'"
              prop="original_transaction_amount"
              required
            >
              <el-input v-model.trim="form.original_transaction_amount" placeholder="Original transaction amount" class="from-input" size="small" type="text" clearable />
            </el-form-item>

            <el-form-item
              key="refund_amount"
              :label="$t('customerService.request_refund_amount') + ':'"
              prop="refund_amount"
              required
            >
              <el-input v-model="form.refund_amount" placeholder="Enter amount" class="from-input" size="small" type="text" clearable />
            </el-form-item>

          </template>

          <!-- <div v-if="form.operation_type === 1" class="line-bottom-1px" style="margin-bottom: 32px" /> -->
          <el-row>
            <el-col :span="24">
              <!--金额-->
              <el-form-item
                v-if="form.operation_type === 1 || form.operation_type === 2"
                key="amount"
                :label="$t('components.amount') + ':'"
                prop="amount"
                required
              >
                <el-input v-model="form.amount" placeholder="Enter amount" class="from-input" type="text" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="24">

              <!--客户手机号-->
              <el-form-item key="phone_no" prop="phone_no" :label="$t('customerService.customer_phone_number')" required>
                <el-input v-model="form.phone_no" placeholder="Enter customer mobile no." class="from-input" type="text" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="form.operation_type === 1 || form.operation_type === 4">
            <el-col :span="24">
              <!--交易时间 -->
              <el-form-item
                key="transaction_date"
                prop="transaction_date"
                :rules="[
                  { required: true, message: 'Transaction Date cannot be empty', trigger: 'blur'}
                ]"
              >
                <template slot="label">
                  <span>{{ $t('components.transaction_date') }}</span>
                  <el-tooltip>
                    <div slot="content">
                      <span>{{ $t('tips.transaction_time') }}</span> <br>
                    </div>
                    <span>   <svg-icon style="position:relative; top: -1px" icon-class="help-question" /></span>
                  </el-tooltip>
                </template>
                <el-date-picker
                  v-model="form.transaction_date"
                  class="from-input"

                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="Enter transaction time"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <!--原因-->
              <el-form-item
                :key="form.operation_type"
                :label="$t('customerService.description') + ':'"
                prop="issue"
                required
              >
                <el-input v-model="form.issue" placeholder="Enter your message here" class="from-input" type="textarea" clearable @input="enterInput(form.issue,'Description')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row style="margin-bottom: 24px">
            <el-col :span="24" style="display: flex">
              <div class="upload-label">
                <span v-if="form.operation_type === 1 ||form.operation_type === 4 " class="upload-label-text">
                  <span
                    style="color: #71110e; margin-right: 4px;"
                  >*</span>
                  {{ $t('customerService.payment_receipt') }}<br> ({{ $t('tips.image_only') }})
                </span>

                <span v-if="form.operation_type === 2" class="upload-label-text">
                  <span
                    style="color: #71110e; margin-right: 4px;"
                  >*</span>{{ $t('customerService.transaction_history') }}<br> ({{ $t('tips.image_only') }})
                </span>

                <el-tooltip>
                  <div slot="content">
                    <span>{{ $t('tips.payment_receipt') }}</span> <br>
                  </div>
                  <span> <svg-icon icon-class="help-question" /></span>
                </el-tooltip>
              </div>

              <!-- 付款凭证 -->
              <el-upload
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :file-list="form.fileList"
                :limit="1"
                :on-change="handleImageChange"
                :class="{'hideUploadFlag': isHideUpdate,'upload-image':true}"
              >
                <div slot="default"><el-button type="primary" plain>Click here to upload image</el-button></div>

                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in" />
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                      <i class="el-icon-delete" />
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" style="display: flex">
              <div class="upload-label">
                <span class="upload-label-text">{{ $t('customerService.attachments') }}</span>
              </div>

              <el-upload
                action="#"
                :auto-upload="false"
                :file-list="form.attachmentList"
                :limit="3"
                :on-change="handleAttachmentChange"
                :on-exceed="handleExceed"
                :on-remove="handleAttachmentRemove"
                :disabled="uploadAttachmentLoading"
                :class="{'hideUploadFlag': isHideAttachmentUpdate,'upload-image':true}"
              >
                <div slot="default" class="upload-file-defaule" :loading="uploadAttachmentLoading"><el-button type="primary" plain>Click here to attach file</el-button></div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="dialog-footer">
        <!-- <el-button @click="dialogUploadVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submitLoading" class="btn-submit" @click="onClickSubmitBtn('form')">{{
          $t('components.submit')
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { addTicket } from '@/api/customer-service/customer-service'
import { merchantProductMap } from '@/utils/maps'
import { uploadImg, uploadFile } from '@/api/components/upload'
import { validateMobile } from '@/utils/validate'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'

export default {
  name: 'Add_Ticket_Modal',
  props: {
    instituteCategoryArr: {
      type: Array,
      require: true,
      default: function() {
        return []
      }
    }
  },
  data() {
    const checkNumberType = (rule, value, callback) => {
      if (value !== '0' && !Number(value)) {
        return callback(new Error('only can input number'))
      }
      return callback()
    }
    const checkInput = (rule, value, callback) => {
      if (this.form.payment_method === 1) {
        if (!this.form.qrcode_id && !this.form.qr_link && !this.form.merchant_order_id) {
          return callback(new Error('Please provide at least one of QR Link,QR Code ID or Merchant Order ID'))
        }
        // if (value) {
        //   this.$refs['form'].clearValidate(['qrcode_id'])
        //   this.$refs['form'].clearValidate(['qr_link'])
        // }
        this.$refs['form'].clearValidate(['qrcode_id'])
        this.$refs['form'].clearValidate(['qr_link'])
        this.$refs['form'].clearValidate(['merchant_order_id'])
      }
      return callback()
    }
    return {
      uploadLoading: false,
      uploadAttachmentLoading: false,
      paymentMethodArr: [
        { label: 'QR Code', value: 1 }
      ],
      form: {
        operation_type: 1,
        payment_method: null,
        institute_id: null,
        transaction_id: null,
        amount: null,
        phone_no: null,
        transaction_date: null,
        issue: null,
        pic_path: null,
        file_path: [],
        fileList: [],
        attachmentList: [],
        attachmentMap: new Map()
      },
      rules: {
        phone_no: [
          { required: true, message: 'Mobile no. cannot be empty' },
          { validator: checkNumberType, trigger: ['blur', 'change'] }
        ],
        amount: [
          { required: true, message: 'Amount cannot be empty' },
          { validator: checkNumberType, trigger: ['blur', 'change'] }
        ],
        merchant_order_id: [
          { required: true, message: 'Merchant Order Id cannot be empty' },
          { validator: checkInput, trigger: ['blur', 'change'] }
        ]
      },
      dialogUploadVisible: false,
      submitLoading: false,
      dialogImageUrl: '',
      dialogImageVisible: false
    }
  },
  computed: {
    merchantProductMap() {
      return merchantProductMap()
    },
    instituteTypeArr() {
      return this.instituteCategoryArr.filter(item => item.institute_type === this.form.operation_type)
    },
    isHideUpdate() {
      return this.form.fileList && this.form.fileList.length > 0
    },
    isHideAttachmentUpdate() {
      return this.form.attachmentList && this.form.attachmentList.length > 2
    }
  },
  methods: {
    initData() {
      this.uploadLoading = false
      this.uploadAttachmentLoading = false
      this.form = {
        operation_type: 1,
        institute_id: null,
        transaction_id: null,
        amount: null,
        phone_no: null,
        transaction_date: null,
        issue: null,
        pic_path: null,
        file_path: '',
        fileList: [],
        attachmentList: [],
        attachmentMap: new Map()
      }
      this.dialogUploadVisible = false
      this.submitLoading = false
    },
    handleDialogOpen() {
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogUploadVisible = value
    },
    handleDialogClose() {
      this.initData()
      this.$refs['form'].clearValidate()
    },
    handleRemove(file) {
      this.form.fileList = this.form.fileList.filter(item => item.uid !== file.uid)
      this.form.pic_path = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    handleImageChange(file, fileList) {
      this.form.fileList = []

      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }

      this.uploadLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', 'MERCHANT_TICKET')
      uploadImg(formData).then(res => {
        this.$message.success('Image upload successfully!')
        this.form.pic_path = res.data.path
        this.form.fileList = [file]
      }).finally(() => {
        this.uploadLoading = false
      })
    },
    handleAttachmentChange(file, fileList) {
      this.form.attachmentList = fileList
      this.uploadAttachmentLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', 'MERCHANT_TICKET')
      uploadFile(formData).then(res => {
        this.$message.success('File upload successfully!')
        this.form.attachmentMap.set(file.uid, file.name + ':' + res.data.path)
      }).catch(() => { // 上传失败移除预上传的文件
        this.form.attachmentList = this.form.attachmentList.filter(item => item.uid !== file.uid)
      }).finally(() => {
        this.uploadAttachmentLoading = false
      })
    },
    handleAttachmentRemove(file) {
      this.form.attachmentMap.delete(file.uid)
    },
    handleExceed() {
      this.$message.warning('Cannot upload more than 3 files')
    },
    changePaymethod() {
      this.$refs['form'].clearValidate(['qrcode_id'])
      this.$refs['form'].clearValidate(['qr_link'])
      this.$refs['form'].clearValidate(['merchant_order_id'])
    },
    onChangeProduct() {
      this.form.institute_id = null
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.uploadLoading) {
            this.$message.warning('Image uploading, please submit later!')
            return
          }
          if (this.uploadAttachmentLoading) {
            this.$message.warning('Attachment uploading, please submit later!')
            return
          }
          if (!this.form.fileList[0] && this.form.operation_type !== 3) {
            this.$message.warning('Please select upload file!')

            return
          }
          if (this.form.fileList[0] && !this.form.pic_path) {
            this.$message.warning('Upload failed, please upload the image again!')
            return
          }
          if (this.form.issue.length > 250) {
            this.$message.warning(`The longest length of the Description is 250`)
            return
          }

          const { account_no, payment_method, transaction_date, amount, qr_link, qrcode_id, refund_amount, original_transaction_amount, ...params } = this.form
          if (params.operation_type === 1) { // 收单
            if (transaction_date) {
              params.transaction_date = transaction_date
            }
            if (payment_method) {
              params.payment_method = payment_method
            }
            if (params.payment_method === 1) { // QRCODE
              if (qrcode_id) {
                params.qrcode = qrcode_id
              }
              if (qr_link) {
                params.qr_link = qr_link
              }
            }
          }

          if (params.operation_type === 4) {
            if (transaction_date) {
              params.transaction_date = transaction_date
            }
            params.refund_amount = this.$commonFn.mathMultiply(refund_amount, 100)
            params.original_transaction_amount = this.$commonFn.mathMultiply(original_transaction_amount, 100)
          }

          if (this.form.attachmentMap) {
            var tmpList = []
            for (const item of this.form.attachmentMap.values()) {
              tmpList.push(item)
            }
            params.file_path = JSON.stringify(tmpList)
          }
          // 公共部分
          if (amount) {
            params.amount = this.$commonFn.mathMultiply(Number(amount), 100)
          }
          if (params.phone_no) {
            params.phone_no = cryptoJSAesEncrypt(params.phone_no)
          }

          this.submitLoading = true

          addTicket(params).then(res => {
            this.$message.success('Add Success!')
            this.$emit('updateList')
            this.changModalStatus(false)
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    enterInput(value, text) {
      if (value.length > 250) {
        this.$message.warning(`The longest length of the ${text} is 250`)
      }
    }
  }

}
</script>

<style>
.add-ticket-modal .el-upload--picture-card{
  background-color: #fff;
  border: none;
  width: auto;
  height: auto;
  cursor: pointer;
  line-height: 1.2;
  text-decoration-line: underline;
  color: #3855F1;
}
 .content::-webkit-scrollbar{
    width:4px;
    /* height:2px; */
    /**/
  }
  .content::-webkit-scrollbar-track{
    background: #D2D8E3;
    border-radius:2px;
  }
  .content::-webkit-scrollbar-thumb{
    background: #98A1B4;
    border-radius:10px;
  }
  .content::-webkit-scrollbar-thumb:hover{
    background: #98A1B4;
  }
  .content::-webkit-scrollbar-corner{
    background: #179a16;
  }
</style>

<style scoped>
.upload-file-defaule{
}
.content{
  padding-right: 20px;
  height: 600px;
  overflow: auto;
}
.icon-question{
  position: relative;
  top: -4px;
  margin-left: 5px;
  display: inline-block;
  height: 12px;
  width: 12px;

}

.input-base {
  width: 200px;
}

.input-url {
  width: 400px;
}

.search-btn {
  margin-left: 10px;
}

.upload-bill {
  width: 100px;
}
.upload-label{
  display: inline-block;
  width: 230px;
}
.upload-label-text{
  vertical-align: top;
  font-size: 14px;
  line-height: 1.2;

}
.payment-receipt{
  display: inline-block;
  width: 150px;
  position: relative;
}
.image-only{
  position: absolute;
  top: 20px;
  left: -3px;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.2;
}
.payment-tip{
  position: relative;
  left: 19px;
  word-break: keep-all;
  line-height: 24px;
}
.upload-image{
  display: inline-block;
}
.dialog-footer{
  margin-top: 64px;
  text-align: center;
}
.btn-submit{
  width: 100%;
}
</style>
